let payrate = 0.5
try {
if (localStorage.getItem('payrate') != null) {
    payrate = Number(localStorage.getItem('payrate'))
}
} catch (e) {
    payrate = 0.5
}

export default payrate